import Alpine from "alpinejs";

Alpine.data('DownloadModal', () => ({
    showModal: false,
    queryString: null,
    get modalUrl() {
        return 'keyDates/download?' + this.queryString
    },
    openModal(query){
        this.queryString = query;
        this.showModal = true;
    }
}));